/**
 * Local Storage Saga
 */

import * as actions from '../actions/localStorage';
import {
  createItem,
  getLocalStorageKeys,
  removeAllSessionItems,
  removeItem,
  updateStoredItem,
} from '../helpers/localStorage';

import { effects as fx } from 'redux-saga';
import { Action } from 'typescript-fsa';
import { decodeFromUrl } from '../../utils/url';

export function* init() {
  yield fx.all([
    fx.takeEvery(actions.clearLocalStorage, clearLocalStorage),
    fx.takeEvery(actions.removeFromLocalStorage, removeFromLocalStorage),
    fx.takeEvery(actions.saveToLocalStorage, saveToLocalStorage),
    fx.takeEvery(actions.getItemFromLocalStorage.started, getItemFromLocalStorage),
  ]);
}

function* removeFromLocalStorage({ payload: { key } }: Action<IGetItemFromLocalStorageActionPayload>) {
  return removeItem(key);
}

function* saveToLocalStorage({ payload: { key, merge, replace, value } }: Action<ISaveToLocalStorageActionPayload>) {
  replace || merge ?
    updateStoredItem(key, value, merge)
    : createItem(key, value);
}

function* getItemFromLocalStorage({ payload }: Action<IGetItemFromLocalStorageActionPayload>) {
  const storedItemKey = getLocalStorageKeys(payload.key);
  if (storedItemKey.length > 0) {
    const data = decodeFromUrl(localStorage.getItem(storedItemKey[0])!);
    yield fx.put(actions.getItemFromLocalStorage.done({ params: payload, result: data }));
  } else {
    const error = { message: `No local storage item found for suffix ${payload.key}` };
    yield fx.put(actions.getItemFromLocalStorage.failed({ params: payload, error }));
  }
}

function* clearLocalStorage() {
  removeAllSessionItems();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/localStorage.ts